module.exports = __webpack_public_path__ + "img/pic-freefire.e7784ed.png";